// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar___EYgB","bgWhite":"Header_bgWhite__vm_rA","hidden":"Header_hidden__o37XJ"};